import { AppConfig } from 'AppConfig';

export const formatReptSource = (tbUrl, tenantCd, suffix) => {
  return `${tbUrl}/${AppConfig.REPT_SRC_PREFIX}/${tenantCd}/views/${suffix}`;
};
